import { Drawer, Typography } from '@mui/material';
import React from 'react';
import { Player } from '../../types';
import { PoolPlayLeaderboard } from '../PoolPlayLeaderboard';

type PropTypes = {
  cutoff?: number;
  gameOver: boolean;
  handlePoolLeaderboardUsernameClick: (profileId: string) => void;
  poolLeaderboardDrawerWidth: number;
  profileId: string;
  roundOver: boolean;
  sortedPlayers?: Player[];
  showClickTip?: boolean;
};

export const LeaderboardDrawer = ({
  cutoff,
  gameOver,
  handlePoolLeaderboardUsernameClick,
  poolLeaderboardDrawerWidth,
  profileId,
  roundOver,
  sortedPlayers,
  showClickTip,
}: PropTypes) => {
  return (
    <Drawer
      sx={{
        width: `${poolLeaderboardDrawerWidth}px`,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: `${poolLeaderboardDrawerWidth}px`,
          boxSizing: 'border-box',
          bgcolor: '#333333',
        },
      }}
      variant="permanent"
      anchor="right"
    >
      <Typography variant={'h4'} textAlign={'center'} letterSpacing={3}>
        LEADERBOARD
      </Typography>
      <Typography variant={'caption'} textAlign={'center'} letterSpacing={3}>
        {`Total Players: ${sortedPlayers?.length}`}
      </Typography>
      {showClickTip ? (
        <Typography
          variant={'caption'}
          textAlign={'center'}
          color="warning.main"
          marginTop={1}
        >
          Click player to view their scores
        </Typography>
      ) : null}
      <PoolPlayLeaderboard
        cutoff={cutoff}
        gameOver={gameOver}
        onUsernameClick={handlePoolLeaderboardUsernameClick}
        sortedPlayers={sortedPlayers}
        profileId={profileId}
        roundOver={roundOver}
      ></PoolPlayLeaderboard>
    </Drawer>
  );
};
